import { useRecoilState } from 'recoil';
import { Button } from 'components/core';
import { builderAnswersState } from 'states';
import { ExtraSetting } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';



// Advanced: any other setting hand-written JSON could put in the config. The dashboard or handler must read it.
export const ExtraSettingsStep = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const settings = a.extras.settings;
  const save = (next: ExtraSetting[]) => setA({ ...a, extras: { ...a.extras, settings: next } });
  const set = (i: number, next: Partial<ExtraSetting>) => save(settings.map((s, j) => (j === i ? { ...s, ...next } : s)));

  return (
    <BuilderSection title="Extra settings (advanced)" hint="Add any other setting for the config, such as minThreshold with 70, or enableChartSearch with true. A number, true or false, or a list is saved as such; anything else is saved as text. It only matters if the dashboard or handler reads that setting. Settings added here replace a setting with the same name.">
      {settings.map((s, i) => (
        <div key={i} className="row g-2 mb-2">
          <div className="col-md-4"><TextBox value={s.key} placeholder="Setting name" onChange={(key) => set(i, { key })} /></div>
          <div className="col-md-6"><TextBox value={s.value} placeholder="Value, e.g. 70 or true or [1, 2]" onChange={(value) => set(i, { value })} /></div>
          <div className="col-md-2"><Button {...OUTLINE_SMALL} onClick={() => save(settings.filter((_, j) => j !== i))}>Remove</Button></div>
        </div>
      ))}
      <Button {...OUTLINE_SMALL} onClick={() => save([...settings, { key: '', value: '' }])}>Add a setting</Button>
    </BuilderSection>
  );
};
